import { createStore } from "vuex";

function readLocalStorage(key, fallback = "") {
    if (typeof window === "undefined") return fallback;
    return window.localStorage?.getItem(key) || fallback;
}

function writeLocalStorage(key, value) {
    if (typeof window === "undefined") return;
    window.localStorage?.setItem(key, value);
}

const store = {
    state: {
        token: readLocalStorage("token"),
        user: {},
        code: "",

        express_phone_erp: "",
        express_phone_sys: "",

        apply_info: {
            checked: -1,
        },
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        logout(state) {
            state.token = "";
            writeLocalStorage("token", "");
        },
        SET_USER_INFO(state, user) {
            state.user = user;
        },
        SET_CODE(state, code) {
            state.code = code;
        },
        SET_STATE(state, { key, value }) {
            state[key] = value;
        },
    },
    getters: {},
    actions: {
        setApplyInfo({ commit }, info) {
            commit("SET_STATE", {
                key: "apply_info",
                value: info,
            });
        },
    },
};

export default createStore(store);
